import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable &&
        <Box className="mtska-kpi-set">

            <KPI
                title="Lead totali"
                icon="faPerson"
                className="highlighted"
                dataProviderName={'statistics/item/count/audiences/audienceLead'}
            />
            <KPI
                title="Controlli totali"
                icon="faFolderCheck"
                dataProviderName={'statistics/item/count/audiences/audienceRPOCheck'}
            />
            <KPI
                title="Lead controllate"
                icon="faUserCheck"
                dataProviderName={'statistics/item/count/audiences/audienceRPOLead'}
            />

        </Box>
    )
}

export default KPISet;